import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import "./Customization.css"
import 'react-accessible-accordion/dist/fancy-example.css';
// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Label,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
} from "reactstrap";
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemState,
} from 'react-accessible-accordion';

import Switch from "react-bootstrap-switch";
import Select, { components } from "react-select";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ImageUpload from "./UploadImage.js";
import ReactTooltip from "react-tooltip";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
const DragHandle = SortableHandle(() => <FontAwesomeIcon
    icon={faGripVertical} title="Reorder Section"
/>);

const SortableParentDiv = SortableContainer(({ children }) =>
    <div className="parent-div">
        {children}
    </div>
)

const SortableChildDiv = SortableElement(({ children }) =>
    <div className="child-div">
        {children}
    </div>
)

const ConfigFormComponent = (props) => {
    var element = [];
    const [showRemove, setShowRemove] = useState(true);
    const [tagInput, setTagInput] = useState('');

    var elementName = props.elementname;
    var elementId = props.elementname;
    var elementDesign = props.data;
    var helpText = elementDesign.helptext ? elementDesign.helptext : "";

    var elementType = elementDesign.type;

    if (elementDesign.source && elementDesign.source == "category_list") {
        elementType = "enum";
        elementDesign.type_items = props.categories;
    }

    if (props.grandparent != "") {
        elementName =
            props.subparent +
            "[" +
            props.parent +
            "]" +
            "[" +
            props.elementname +
            "]";
        elementId =
            props.subparent + ":" + props.parent + ":" + props.elementname;
    } else if (props.subparent != "") {
        elementName = props.parent + "[" + props.elementname + "]";
        elementId = props.parent + ":" + props.elementname;
    }
    const SortableSelect = SortableContainer(Select);

    const SortableMultiValueLabel = SortableHandle((props) => {
        return (
            <components.MultiValueLabel {...props} />
        )
    })

    const SortableMultiValue = SortableElement((props) => {
        const onMouseDown = (e) => {
            e.preventDefault();
            e.stopPropagation();
        };
        const innerProps = { ...props.innerProps, onMouseDown };
        return <components.MultiValue {...props} innerProps={innerProps} />
    });

    const handleInputColorChange = (event) => {
        let inputId = [event.target.id].toString();
        let inputValue = event.target.value;
        let parentsArray = inputId.split(":");
        if (parentsArray.length === 3) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][
                        parentsArray[1]
                        ],
                        [parentsArray[2]]: inputValue,
                    },
                },
            });
        } else if (parentsArray.length === 2) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: inputValue,
                },
            });
        } else {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: inputValue,
            });
        }


    }
    const arrayMove = (arr, from, to) => {
        const slicedArray = arr.slice();
        slicedArray.splice(
            to < 0 ? arr.length + to : to,
            0,
            slicedArray.splice(from, 1)[0]
        );
        return slicedArray;
    }
    const onSortEndMultiInput = ({ oldIndex, newIndex, event, target }) => {
        if (target && target.tagName === 'INPUT') {
            return;
        }
        if (target && target.className && target.className.includes('react-select')) {
            return;
        }

        let currentValue1 = currentValue();

        let newValue = arrayMove(currentValue1, oldIndex, newIndex)

        if (props.currentTabConfig) {
            if (props.grandparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.subparent]: {
                        ...props.currentTabConfig[props.subparent],
                        [props.parent]: {
                            ...props.currentTabConfig[props.subparent][
                            props.parent
                            ],
                            [props.elementname]: newValue,
                        },
                    },
                });
                //props.currentTabConfig[props.subparent][props.parent][props.elementname].push(element);
            } else if (props.subparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.parent]: {
                        ...props.currentTabConfig[props.parent],
                        [props.elementname]: newValue,
                    },
                });
            } else {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.elementname]: newValue,
                });

            }
        }
        if (oldIndex !== newIndex) {
            toast.success("Section Reordered")
        }

    }
    const onSortEndMultiSelect = ({ oldIndex, newIndex }, key, fieldkey, type_items, listFieldId, listField) => {
        // console.log("in sortend props: ",props)
        // console.log("in sortend ",elementId)
        let array = multiInputMultiEnumValue(
            key,
            fieldkey,
            type_items
        );
        // console.log("Array: ",array);
        const newValue = arrayMove(array, oldIndex, newIndex);
        let valueUpdated = handleMultiValueEnumArrayChange(
            listFieldId,
            newValue,
            listField
        );


    }
    const shouldCancelStart = (event) => {
        const targetElement = event.target;
        if (targetElement.className.includes('react-select')) {
            return true;
        }
        return false;
    }
    const handleChange = (event) => {
        let inputId = [event.target.id].toString();
        let inputValue = event.target.value;
        let parentsArray = inputId.split(":");
        if (parentsArray.length === 3) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][
                        parentsArray[1]
                        ],
                        [parentsArray[2]]: inputValue,
                    },
                },
            });
        } else if (parentsArray.length === 2) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: inputValue,
                },
            });
        } else {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: inputValue,
            });
        }

        props.validateConfigField(inputId, inputValue, elementDesign, "field");
    };

    const handleBlur = (event) => {
        let input_id = [event.target.id];
        let input_value = [event.target.value];
        props.validateConfigField(input_id.toString(), event.target.value, elementDesign, "field");
    };

    const handleMultiValueChange = (
        inputId,
        event,
        multiValueElementDesign
    ) => {
        //console.log(inputId);
        //console.log(event.target.value);
        let inputValue = event.target.value;
        let parentsArray = inputId.split(":");
        if (parentsArray.length === 5) {
            let multiInputArray =
                props.currentTabConfig[parentsArray[0]][parentsArray[1]][
                parentsArray[2]
                ];
            multiInputArray[parentsArray[3]][parentsArray[4]] = inputValue;

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][
                        parentsArray[1]
                        ],
                        [parentsArray[2]]: multiInputArray,
                    },
                },
            });

            // props.setCurrentTabConfig({
            //   ...props.currentTabConfig,
            //   [parentsArray[0]] : {
            //     ...props.currentTabConfig[parentsArray[0]],
            //     [parentsArray[1]] : {
            //       ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
            //       [parentsArray[2]] : {
            //         ...props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]],
            //         [parentsArray[3]] : {
            //           ...props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]][parentsArray[3]],
            //           [parentsArray[4]] : inputValue,
            //         }
            //       }
            //     }
            //   }
            // });
        } else if (parentsArray.length === 4) {
            let multiInputArray =
                props.currentTabConfig[parentsArray[0]][parentsArray[1]];
            multiInputArray[parentsArray[2]][parentsArray[3]] = inputValue;

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: multiInputArray,
                },
            });

            // props.setCurrentTabConfig({
            //   ...props.currentTabConfig,
            //   [parentsArray[0]] : {
            //     ...props.currentTabConfig[parentsArray[0]],
            //     [parentsArray[1]] : {
            //       ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
            //       [parentsArray[2]] : {
            //         ...props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]],
            //         [parentsArray[3]] : inputValue,
            //       }
            //     }
            //   }
            // });
        } else {
            let multiInputArray = props.currentTabConfig[parentsArray[0]];
            multiInputArray[parentsArray[1]][parentsArray[2]] = inputValue;

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: multiInputArray,
            });

            // props.setCurrentTabConfig({
            //   ...props.currentTabConfig,
            //   [parentsArray[0]] : {
            //     ...props.currentTabConfig[parentsArray[0]],
            //     [parentsArray[1]] : {
            //       ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
            //       [parentsArray[2]] : inputValue,
            //     }
            //   }
            // });
        }
        props.validateConfigField(
            inputId,
            inputValue,
            multiValueElementDesign,
            "field"
        );
        //console.log(props.currentTabConfig);
    };

    const handleMultiValueEnumChange = (
        inputId,
        inputValue,
        multiValueEnumDesign
    ) => {
        //let inputValue = event.target.value;
        // console.log(inputId);
        // console.log(inputValue);
        let parentsArray = inputId.split(":");

        if (parentsArray.length === 5) {
            let multiInputArray =
                props.currentTabConfig[parentsArray[0]][parentsArray[1]][
                parentsArray[2]
                ];
            multiInputArray[parentsArray[3]][parentsArray[4]] =
                inputValue.value;
            if (multiValueEnumDesign.dependent_field) {
                multiInputArray[parentsArray[3]][
                    multiValueEnumDesign.dependent_field
                ] = inputValue.label;
            }

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][
                        parentsArray[1]
                        ],
                        [parentsArray[2]]: multiInputArray,
                    },
                },
            });
        } else if (parentsArray.length === 4) {
            let multiInputArray =
                props.currentTabConfig[parentsArray[0]][parentsArray[1]];
            multiInputArray[parentsArray[2]][parentsArray[3]] =
                inputValue?.value;
            if (multiValueEnumDesign.dependent_field) {
                multiInputArray[parentsArray[2]][
                    multiValueEnumDesign.dependent_field
                ] = inputValue.label;
            }

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: multiInputArray,
                },
            });
        } else {
            let multiInputArray = props.currentTabConfig[parentsArray[0]];
            multiInputArray[parentsArray[1]][parentsArray[2]] =
                inputValue.value;
            if (multiValueEnumDesign.dependent_field) {
                multiInputArray[parentsArray[1]][
                    multiValueEnumDesign.dependent_field
                ] = inputValue.label;
            }

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: multiInputArray,
            });
        }

        // if(multiValueEnumDesign.dependent_field){
        //   if(parentsArray.length===5){
        //     props.setCurrentTabConfig({
        //       ...props.currentTabConfig,
        //       [parentsArray[0]] : {
        //         ...props.currentTabConfig[parentsArray[0]],
        //         [parentsArray[1]] : {
        //           ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
        //           [parentsArray[2]] : {
        //             ...props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]],
        //             [parentsArray[3]] : {
        //               ...props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]][parentsArray[3]],
        //               [multiValueEnumDesign.dependent_field] : inputValue.label,
        //               [parentsArray[4]] : inputValue.value,
        //             }
        //           }
        //         }
        //       }
        //     });
        //   }else if(parentsArray.length===4){
        //     props.setCurrentTabConfig({
        //       ...props.currentTabConfig,
        //       [parentsArray[0]] : {
        //         ...props.currentTabConfig[parentsArray[0]],
        //         [parentsArray[1]] : {
        //           ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
        //           [parentsArray[2]] : {
        //             ...props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]],
        //             [multiValueEnumDesign.dependent_field] : inputValue.label,
        //             [parentsArray[3]] : inputValue.value,
        //           }
        //         }
        //       }
        //     });
        //   }else{
        //     props.setCurrentTabConfig({
        //       ...props.currentTabConfig,
        //       [parentsArray[0]] : {
        //         ...props.currentTabConfig[parentsArray[0]],
        //         [parentsArray[1]] : {
        //           ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
        //           [multiValueEnumDesign.dependent_field] : inputValue.label,
        //           [parentsArray[2]] : inputValue.value,
        //         }
        //       }
        //     });
        //   }

        // }else{
        //   if(parentsArray.length===5){
        //     props.setCurrentTabConfig({
        //       ...props.currentTabConfig,
        //       [parentsArray[0]] : {
        //         ...props.currentTabConfig[parentsArray[0]],
        //         [parentsArray[1]] : {
        //           ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
        //           [parentsArray[2]] : {
        //             ...props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]],
        //             [parentsArray[3]] : {
        //               ...props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]][parentsArray[3]],
        //               [parentsArray[4]] : inputValue.value,
        //             }
        //           }
        //         }
        //       }
        //     });
        //   }else if(parentsArray.length===4){
        //     props.setCurrentTabConfig({
        //       ...props.currentTabConfig,
        //       [parentsArray[0]] : {
        //         ...props.currentTabConfig[parentsArray[0]],
        //         [parentsArray[1]] : {
        //           ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
        //           [parentsArray[2]] : {
        //             ...props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]],
        //             [parentsArray[3]] : inputValue.value,
        //           }
        //         }
        //       }
        //     });
        //   }else{
        //     props.setCurrentTabConfig({
        //       ...props.currentTabConfig,
        //       [parentsArray[0]] : {
        //         ...props.currentTabConfig[parentsArray[0]],
        //         [parentsArray[1]] : {
        //           ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
        //           [parentsArray[2]] : inputValue.value,
        //         }
        //       }
        //     });
        //   }

        // }
        props.validateConfigField(
            inputId,
            inputValue.value,
            multiValueEnumDesign
        );
        //console.log(props.currentTabConfig);
    };
    const handleMultiValueEnumArrayChange = (
        inputId,
        inputValue,
        multiValueEnumDesign
    ) => {
        //let inputValue = event.target.value;
        console.log("in handleMultiValueMultiEnumChange: id", inputId);
        console.log("in handleMultiValueMultiEnumChange: in value", inputValue);

        let saveValue = [];
        if (inputValue && inputValue.length) {
            inputValue.forEach(function (saveddetails) {
                saveValue.push(saveddetails.value);
            });
        }

        let parentsArray = inputId.split(":");

        if (parentsArray.length === 5) {
            let multiInputArray =
                props.currentTabConfig[parentsArray[0]][parentsArray[1]][
                parentsArray[2]
                ];
            multiInputArray[parentsArray[3]][parentsArray[4]] =
                saveValue;
            if (multiValueEnumDesign.dependent_field) {
                multiInputArray[parentsArray[3]][
                    multiValueEnumDesign.dependent_field
                ] = saveValue[0]?.label;
            }

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][
                        parentsArray[1]
                        ],
                        [parentsArray[2]]: multiInputArray,
                    },
                },
            });
        } else if (parentsArray.length === 4) {
            let multiInputArray =
                props.currentTabConfig[parentsArray[0]][parentsArray[1]];
            multiInputArray[parentsArray[2]][parentsArray[3]] =
                saveValue;
            if (multiValueEnumDesign.dependent_field) {
                multiInputArray[parentsArray[2]][
                    multiValueEnumDesign.dependent_field
                ] = saveValue[0]?.label;
            }

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: multiInputArray,
                },
            });
        } else {
            let multiInputArray = props.currentTabConfig[parentsArray[0]];
            multiInputArray[parentsArray[1]][parentsArray[2]] =
                saveValue.value;
            if (multiValueEnumDesign.dependent_field) {
                multiInputArray[parentsArray[1]][
                    multiValueEnumDesign.dependent_field
                ] = saveValue[0]?.label;
            }

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: multiInputArray,
            });
        }

        props.validateConfigField(
            inputId,
            inputValue.value,
            multiValueEnumDesign
        );
        //console.log(props.currentTabConfig);
    };

    const handleEnumChange = (inputId, inputValue) => {
        //console.log(inputId);
        //console.log(inputValue);
        // console.log(elementDesign);
        let parentsArray = inputId.split(":");
        if (parentsArray.length === 3 && props.currentTabConfig) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][
                        parentsArray[1]
                        ],
                        [parentsArray[2]]: inputValue.value,
                    },
                },
            });
        } else if (parentsArray.length === 2) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: inputValue.value,
                },
            });
        } else {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: inputValue.value,
            });
        }

        if (elementDesign.dependent_field) {
            if (parentsArray.length === 3) {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [parentsArray[0]]: {
                        ...props.currentTabConfig[parentsArray[0]],
                        [parentsArray[1]]: {
                            ...props.currentTabConfig[parentsArray[0]][
                            parentsArray[1]
                            ],
                            [elementDesign.dependent_field]: inputValue.label,
                        },
                    },
                });
            } else if (parentsArray.length === 2) {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [parentsArray[0]]: {
                        ...props.currentTabConfig[parentsArray[0]],
                        [elementDesign.dependent_field]: inputValue.label,
                    },
                });
            } else {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [elementDesign.dependent_field]: inputValue.label,
                });
            }
        }

        props.validateConfigField(inputId, inputValue.value, elementDesign);
        //console.log(props.currentTabConfig);
    };

    const currentEnumValue = () => {
        let value;
        let savedvalue = "";
        //console.log(props.currentTabConfig);
        if (props.currentTabConfig) {
            if (props.grandparent != "") {
                //console.log(props.currentTabConfig[props.subparent][props.parent][props.elementname]);
                if (props.currentTabConfig[props.subparent] && props.currentTabConfig[props.subparent][props.parent]) {
                    savedvalue =
                        props.currentTabConfig[props.subparent][props.parent][props.elementname];
                } else {
                    savedvalue = "";
                }
                // savedvalue =
                //     props.currentTabConfig[props.subparent][props.parent][
                //         props.elementname
                //     ];
            } else if (props.subparent != "") {
                //console.log(props.currentTabConfig[props.parent][props.elementname]);
                if (props.currentTabConfig[props.parent]) {
                    savedvalue = props.currentTabConfig[props.parent][props.elementname];
                } else {
                    savedvalue = "";
                }

            } else {
                //console.log(props.currentTabConfig[props.elementname]);
                savedvalue = props.currentTabConfig[props.elementname];
            }
        }
        if ((savedvalue === undefined || savedvalue === "") && elementDesign.default !== undefined) {
            savedvalue = elementDesign.default;
        }
        elementDesign.type_items.forEach(function (sdetails) {
            if (sdetails.value == savedvalue) {
                value = sdetails;
            }
        });

        return value;
    };

    const handleMultiEnumChange = (inputId, inputValue) => {
        // console.log(inputId);
        // console.log(inputValue);
        // console.log(elementDesign);
        let saveValue = [];
        if (inputValue && inputValue.length) {
            inputValue.forEach(function (saveddetails) {
                saveValue.push(saveddetails.value);
            });
        }
        let parentsArray = inputId.split(":");
        if (parentsArray.length === 3) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][
                        parentsArray[1]
                        ],
                        [parentsArray[2]]: saveValue,
                    },
                },
            });
        } else if (parentsArray.length === 2) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: saveValue,
                },
            });
        } else {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: saveValue,
            });
        }
        //console.log(props.currentTabConfig);
    };

    const currentMultiEnumValue = () => {
        let value = [];
        let savedvalue = [];
        //console.log(props.currentTabConfig);
        if (props.currentTabConfig) {
            if (props.grandparent != "") {
                //console.log(props.currentTabConfig[props.subparent][props.parent][props.elementname]);
                if (props.currentTabConfig[props.subparent] && props.currentTabConfig[props.subparent][props.parent]) {
                    savedvalue =
                        props.currentTabConfig[props.subparent][props.parent][
                        props.elementname
                        ];
                } else {
                    savedvalue = ""
                }

            } else if (props.subparent != "") {
                //console.log(props.currentTabConfig[props.parent][props.elementname]);
                if (props.currentTabConfig[props.parent]) {
                    savedvalue = props.currentTabConfig[props.parent][props.elementname];
                }
            } else {
                //console.log(props.currentTabConfig[props.elementname]);
                savedvalue = props.currentTabConfig[props.elementname];
            }
        }

        if (savedvalue && savedvalue.length) {
            savedvalue.forEach(function (saveddetails) {
                elementDesign.type_items.forEach(function (sdetails) {
                    if (sdetails.value == saveddetails) {
                        value.push(sdetails);
                    }
                });
            });
        }
        return value;
    };

 const currentValue = () => {
    let value;

    if (props.currentTabConfig) {
        const { grandparent, subparent, parent, elementname } = props;
        if (grandparent !== "") {
            value = props.currentTabConfig?.[subparent]?.[parent]?.[elementname] ?? "";
        } else if (subparent !== "") {
            value = props.currentTabConfig?.[parent]?.[elementname] ?? "";
        } else {
            value = props.currentTabConfig?.[elementname];
        }
    }

    // Handle default fallback for non-boolean types
    if (elementDesign.type !== 'boolean' && (value === undefined || value === "") && elementDesign.default !== undefined) {
        value = elementDesign.default;
    }

    // Handle boolean-specific edge cases
    if (elementDesign.type === 'boolean') {
        if (value === 'false') return false; // string 'false' should return boolean false
        if ((value === "" || value === undefined) && elementDesign.default !== undefined) {
            value = elementDesign.default;
        }
    }
    return value;
};

    const removeMultiInputValueElement = (indexid) => {
        console.log(indexid);
        let removeindex = indexid - 1;
        let elementValue = currentValue();
        elementValue.splice(removeindex, 1);
        //delete elementValue[removeindex];
        //console.log(elementValue);

        if (props.currentTabConfig) {
            if (props.grandparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.subparent]: {
                        ...props.currentTabConfig[props.subparent],
                        [props.parent]: {
                            ...props.currentTabConfig[props.subparent][
                            props.parent
                            ],
                            [props.elementname]: elementValue,
                        },
                    },
                });
                //props.currentTabConfig[props.subparent][props.parent][props.elementname].push(element);
            } else if (props.subparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.parent]: {
                        ...props.currentTabConfig[props.parent],
                        [props.elementname]: elementValue,
                    },
                });
            } else {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.elementname]: elementValue,
                });
            }
        }

        //console.log(props.currentTabConfig);
    };

    const addMultiInputValueElement = (indexid, element) => {
        let elementValue;
        let currValue = [];
        currValue = currentValue();
        if (currValue && currValue.length) {
            elementValue = currValue;
        } else {
            //elementValue = {};
            elementValue = [];
        }
        //elementValue[indexid] = element;

        elementValue.push(element);
        //console.log(elementValue);
        //console.log(props.currentTabConfig);
        if (props.currentTabConfig) {
            if (props.grandparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.subparent]: {
                        ...props.currentTabConfig[props.subparent],
                        [props.parent]: {
                            ...props.currentTabConfig[props.subparent][
                            props.parent
                            ],
                            [props.elementname]: elementValue,
                        },
                    },
                });
                //props.currentTabConfig[props.subparent][props.parent][props.elementname].push(element);
            } else if (props.subparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.parent]: {
                        ...props.currentTabConfig[props.parent],
                        [props.elementname]: elementValue,
                    },
                });
            } else {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.elementname]: elementValue,
                });

                // props.setFieldStates({
                //   ...props.fieldStates,
                //   ['error_'+props.elementname] : 'has-success',
                //   ['error_message_'+props.elementname] : ''
                // });
            }
        }
        //console.log(props.currentTabConfig);
    };

    const multiInputValue = (index, keyname) => {
        // console.log(index);
        // console.log(keyname);

        let value = "";
        if (props.currentTabConfig) {
            if (props.grandparent != "" && props.currentTabConfig[props.subparent] && props.currentTabConfig[props.subparent][props.parent] && props.currentTabConfig[props.subparent][props.parent][props.elementname]) {
                value = props.currentTabConfig[props.subparent][props.parent][
                    props.elementname
                ][index][keyname];
            } else if (
                props.subparent != "" && props.currentTabConfig[props.parent] &&
                props.currentTabConfig[props.parent][props.elementname]
            ) {
                value =
                    props.currentTabConfig[props.parent][props.elementname][
                    index
                    ][keyname];
            } else {
                if (props.currentTabConfig[props.elementname]) {
                    value =
                        props.currentTabConfig[props.elementname][index][
                        keyname
                        ];
                }
            }
        }
        return value;
    };

    const multiInputMultiEnumValue = (index, keyname, items) => {
        // console.log(index);
        // console.log(keyname);
        // console.log("propsM...",props.currentTabConfig);
        // console.log("propsMMultiInputEnumValue:",index,keyname,items);
        let value = [];
        let savedvalue = [];
        if (props.currentTabConfig) {
            if (
                props.grandparent != "" &&
                props.currentTabConfig[props.subparent][props.parent][
                props.elementname
                ]
            ) {
                savedvalue =
                    props.currentTabConfig[props.subparent][props.parent][
                    props.elementname
                    ][index][keyname];
            } else if (
                props.subparent != "" &&
                props.currentTabConfig[props.parent][props.elementname]
            ) {
                savedvalue =
                    props.currentTabConfig[props.parent][props.elementname][
                    index
                    ][keyname];
            } else {
                if (props.currentTabConfig[props.elementname]) {
                    savedvalue =
                        props.currentTabConfig[props.elementname][index][
                        keyname
                        ];
                }
            }
        }
        if (savedvalue === undefined && elementDesign["type_items"][0][keyname].default !== undefined) {
            savedvalue = elementDesign["type_items"][0][keyname].default;
        }

        console.log("value in configform: of items", items)
        console.log("value in configform: of saveValue", savedvalue)
        if (savedvalue?.length && items) {
            savedvalue.forEach(function (saveddetails) {
                items.forEach(function (sdetails) {
                    console.log("value in configform: itemdetails: ", sdetails)
                    console.log("value in configform: saveddetails: ", saveddetails)
                    if (JSON.stringify(sdetails.value) === JSON.stringify(saveddetails)) {
                        value.push(sdetails);
                    }
                });
            });
        }
        console.log("value in configform: ", value);
        return value;
    };

    const multiInputEnumValue = (index, keyname, items) => {
        // console.log(index);
        // console.log(keyname);
        let value;
        let savedvalue = "";
        if (props.currentTabConfig) {
            if (
                props.grandparent != "" && props.currentTabConfig[props.subparent] && props.currentTabConfig[props.subparent][props.parent] &&
                props.currentTabConfig[props.subparent][props.parent][
                props.elementname
                ]
            ) {
                savedvalue =
                    props.currentTabConfig[props.subparent][props.parent][
                    props.elementname
                    ][index][keyname];
            } else if (
                props.subparent != "" && props.currentTabConfig[props.parent] &&
                props.currentTabConfig[props.parent][props.elementname]
            ) {
                savedvalue =
                    props.currentTabConfig[props.parent][props.elementname][
                    index
                    ][keyname];
            } else {
                if (props.currentTabConfig[props.elementname]) {
                    savedvalue =
                        props.currentTabConfig[props.elementname][index][
                        keyname
                        ];
                }
            }
        }
        if ((savedvalue === undefined || savedvalue == "") && elementDesign["type_items"][0][keyname].default !== undefined) {
            savedvalue = elementDesign["type_items"][0][keyname].default;
        }
        if (items.length) {
            items.forEach(function (itemdetails) {
                if (itemdetails.value == savedvalue) {
                    value = itemdetails;
                }
            });
        }

        return value;
    };
    const handleMultiImageChange = (
        inputId,
        event,
        multiValueElementDesign
    ) => {
        console.log("Handle Multi Image  change:", inputId, event, multiValueElementDesign);
        let inputValue = event.value;
        let parentsArray = inputId.split(":");
        if (parentsArray.length === 5) {
            let multiInputArray =
                props.currentTabConfig[parentsArray[0]][parentsArray[1]][
                parentsArray[2]
                ];
            multiInputArray[parentsArray[3]][parentsArray[4]] = inputValue;

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][
                        parentsArray[1]
                        ],
                        [parentsArray[2]]: multiInputArray,
                    },
                },
            });
        } else if (parentsArray.length === 4) {
            let multiInputArray =
                props.currentTabConfig[parentsArray[0]][parentsArray[1]];
            multiInputArray[parentsArray[2]][parentsArray[3]] = inputValue;

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: multiInputArray,
                },
            });
        } else {
            let multiInputArray = props.currentTabConfig[parentsArray[0]];
            multiInputArray[parentsArray[1]][parentsArray[2]] = inputValue;

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: multiInputArray,
            });
        }
        props.validateConfigField(
            inputId,
            inputValue,
            multiValueElementDesign,
            "field"
        );
    };
    const dropDownCheck = (keyname) => {
        let value;
        if (props.currentTabConfig) {
            if (props.grandparent != "" && props.currentTabConfig?.[props.subparent]?.[props.parent]?.[keyname]
            ) {
                value = props.currentTabConfig[props.subparent][props.parent][keyname];
            } else if (props.subparent != "" && props.currentTabConfig?.[props.parent]?.[keyname]
            ) {
                value = props.currentTabConfig[props.parent][keyname];
            } else {
                if (props.currentTabConfig?.[keyname]) {
                    value = props.currentTabConfig[keyname];
                }
            }
        }
        return value;
    }

    const updateTags = (newTags) => {
        let parentsArray = elementId.split(":");
        if (props.currentTabConfig) {
            if (parentsArray.length === 3) {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [parentsArray[0]]: {
                        ...props.currentTabConfig[parentsArray[0]],
                        [parentsArray[1]]: {
                            ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
                            [parentsArray[2]]: newTags,
                        },
                    },
                });
            } else if (parentsArray.length === 2) {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [parentsArray[0]]: {
                        ...props.currentTabConfig[parentsArray[0]],
                        [parentsArray[1]]: newTags,
                    },
                });
            } else {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [parentsArray[0]]: newTags,
                });
            }
        }
    };

    const handleTagInputKeyDown = (event) => {
        if (event.key === 'Enter' && tagInput.trim() !== '') {
            event.preventDefault();
            const currentTags = currentValue() || [];
            let newTag = tagInput.trim();

            if (elementDesign.value_type === 'integer') {
                if (!/^\d+$/.test(newTag)) {
                    toast.error("Please enter a valid integer.");
                    return;
                }
                newTag = parseInt(newTag, 10);
            }

            if (!currentTags.includes(newTag)) {
                const newTags = [...currentTags, newTag];
                updateTags(newTags);
            } else {
                toast.warn(`Tag "${newTag}" already exists.`);
            }
            setTagInput('');
        }
    };

    const handleRemoveTag = (indexToRemove) => {
        const newTags = (currentValue() || []).filter((_, index) => index !== indexToRemove);
        updateTags(newTags);
    };
    //console.log(props);
    if (elementType == "string") {
        let showField = true;
        if (elementDesign.parent_field) {
            let parentValue = dropDownCheck(elementDesign.parent_field);
            if (parentValue !== elementDesign.parent_value) {
                showField = false;
            }
        }
        let displayField = "";
        if (!showField) {
            displayField = 'none'
        }
        element.push(
            <>
                <Row style={{ display: displayField }}>
                    <Col sm="6">
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}{props.data.required ? <span class="text-danger"> * </span> : ""}
                            </small>
                        </div>
                        {helpText != "" ? (
                            <Label className="smLabl-txt">{helpText}</Label>
                        ) : (
                            ""
                        )}
                    </Col>

                    <Col sm="6">
                        <div className="inptFom1">
                            <FormGroup
                                className={props.fieldStates["error_" + elementId]}>
                                <Input
                                    type="text"
                                    name={elementName}
                                    id={elementId}
                                    value={currentValue()}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />

                                {props.fieldStates["error_" + elementId] ===
                                    "has-danger" ? (
                                    <label className="error" id={props.parent + elementId}>
                                        {
                                            props.fieldStates[
                                            "error_message_" + elementId
                                            ]
                                        }
                                    </label>
                                ) : null}
                            </FormGroup>
                        </div>
                    </Col>
                </Row>
            </>
        );
    } else if (elementType == "boolean") {
        element.push(
            <>
                <Row>
                    <Col sm="6" >
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}{props.data.required ? <span className="text-danger"> * </span> : ""}
                            </small>
                        </div>
                        {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                    </Col>
                    <Col sm="6">
                        <div className="inptFom1">
                            <FormGroup>
                                <Switch
                                    name={elementName}
                                    offColor="success"
                                    offText={
                                        <i className="nc-icon nc-simple-remove" />
                                    }
                                    onColor="success"
                                    onText={<i className="nc-icon nc-check-2" />}
                                    value={currentValue()}
                                    onChange={(value, enabled) =>
                                        handleEnumChange(elementId, {
                                            value: enabled,
                                        })
                                    }
                                />{" "}
                            </FormGroup>
                        </div>
                    </Col>
                </Row>
            </>
        );
    } else if (elementType == "integer") {
        element.push(
            <>
                <Row>
                    <Col sm="6">
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}{props.data.required ? <span class="text-danger"> * </span> : ""}
                            </small>
                        </div>
                        {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                    </Col>
                    <Col sm="6">
                        <div className="inptFom1">
                            <FormGroup
                                className={props.fieldStates["error_" + elementId]}>
                                <Input
                                    type="number"
                                    name={elementName}
                                    id={elementId}
                                    value={currentValue()}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {props.fieldStates["error_" + elementId] ===
                                    "has-danger" ? (
                                    <label className="error" id={props.parent + elementId}>
                                        {
                                            props.fieldStates[
                                            "error_message_" + elementId
                                            ]
                                        }
                                    </label>
                                ) : null}
                            </FormGroup>
                        </div>
                    </Col>
                </Row>
            </>
        );
    } else if (elementType == "hidden") {
        element.push(
            <Row>
                <Col sm="12">
                    <div className="inptFom1">
                        <FormGroup>
                            <Input
                                type="hidden"
                                name={elementName}
                                id={elementId}
                                value={currentValue()}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </FormGroup>
                    </div>
                </Col>
            </Row>
        );
    } else if (elementType == "hex_color") {
        element.push(
            <>
                <Row>
                    <Col sm="6">
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}{props.data.required ? <span class="text-danger"> * </span> : ""}
                            </small>
                        </div>
                        {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                    </Col>
                    <Col sm="6"  >
                        <div className="inptFomColr">
                            <div className="clrChng" style={{ display: "inline-block", border: "none", }}>
                                <input
                                    style={{ background: currentValue() }}
                                    type="color"
                                    name={elementName}
                                    id={elementId}
                                    value={currentValue()}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </div>
                            <div className="clrTxt" style={{ display: "inline-block" }}>
                                <input
                                    //   style={{border:"none" }}
                                    type="text"
                                    name={elementName}
                                    id={elementId}
                                    value={currentValue()}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </>
        );
    } else if (elementType == "url") {
        element.push(
            <>
                <Row>
                    <Col sm="6">
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}{props.data.required ? <span class="text-danger"> * </span> : ""}
                            </small>
                        </div>
                        {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                    </Col>
                    <Col sm="6">
                        <div className="inptFom1">
                            <FormGroup
                                className={props.fieldStates["error_" + elementId]}>
                                <Input
                                    type="url"
                                    name={elementName}
                                    id={elementId}
                                    value={currentValue()}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {props.fieldStates["error_" + elementId] ===
                                    "has-danger" ? (
                                    <label className="error" id={props.parent + elementId}>
                                        {
                                            props.fieldStates[
                                            "error_message_" + elementId
                                            ]
                                        }
                                    </label>
                                ) : null}
                            </FormGroup>
                        </div>
                    </Col>
                </Row>
            </>
        );
    } else if (elementType == "enum" && elementDesign.type == "array") {
        //console.log(elementName);

        element.push(
            <>
                <Row>
                    <Col sm="6">
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}{props.data.required ? <span class="text-danger"> * </span> : ""}
                            </small>
                        </div>
                        {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                    </Col>
                    <Col sm="6">
                        <div className="inptFom1">
                            <FormGroup
                                className={props.fieldStates["error_" + elementId]}>
                                <Select
                                    className="react-select primary"
                                    classNamePrefix="react-select"
                                    name={elementName}
                                    // id={elementId}
                                    isMulti="true"
                                    hideSelectedOptions={false}
                                    value={currentMultiEnumValue()}
                                    options={elementDesign.type_items}
                                    onChange={(value) =>
                                        handleMultiEnumChange(elementId, value)
                                    }
                                    closeMenuOnSelect={false}
                                />
                                {props.fieldStates["error_" + elementId] ===
                                    "has-danger" ? (
                                    <label className="error" id={props.parent + elementId}>
                                        {
                                            props.fieldStates[
                                            "error_message_" + elementId
                                            ]
                                        }
                                    </label>
                                ) : null}
                                <div id={elementId} tabIndex="0"></div>
                            </FormGroup>
                        </div>
                    </Col>
                </Row>
            </>
        );
    } else if (elementType == "enum") {
        // console.log(elementName);
        let showField = true;
        if (elementDesign.parent_field) {
            let parentValue = dropDownCheck(elementDesign.parent_field);
            if (parentValue !== elementDesign.parent_value) {
                showField = false;
            }
        }
        let displayField = "";
        if (!showField) {
            displayField = 'none'
        }
        element.push(
            <>
                <Row style={{ display: displayField }}>
                    <Col sm="6">
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}{props.data.required ? <span class="text-danger"> * </span> : ""}
                            </small>
                        </div>
                        {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                    </Col>
                    <Col sm="6">
                        <div className="inptFom1">
                            <FormGroup
                                className={props.fieldStates["error_" + elementId]}>
                                <Select
                                    className="react-select primary"
                                    classNamePrefix="react-select"
                                    name={elementName}
                                    // id={elementId}
                                    value={currentEnumValue()}
                                    options={elementDesign.type_items}
                                    onChange={(value) =>
                                        handleEnumChange(elementId, value)
                                    }
                                />
                                {props.fieldStates["error_" + elementId] ===
                                    "has-danger" ? (
                                    <label className="error" id={props.parent + elementId}>
                                        {
                                            props.fieldStates[
                                            "error_message_" + elementId
                                            ]
                                        }
                                    </label>
                                ) : null}
                                <div id={elementId} tabIndex="0"></div>
                            </FormGroup>
                        </div>
                    </Col>
                </Row>
            </>
        );
    } else if (elementType == "file_upload") {

        element.push(
            <>
                <Row>
                    <Col sm="6">
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}
                                {elementDesign.size ? (
                                    <span>({elementDesign.size})</span>
                                ) : (
                                    ""
                                )}{props.data.required ? <span class="text-danger"> * </span> : ""}
                            </small>
                        </div>
                        {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                    </Col>
                    <Col sm="6">
                        <div className="inptFom1">
                            <FormGroup
                                className={props.fieldStates["error_" + elementId]}>
                                <ImageUpload
                                    imageDetails={elementDesign}
                                    elementValue={
                                        props.currentTabConfig ? currentValue() : ""
                                    }
                                    id={elementId}
                                    handleEnumChange={handleEnumChange}
                                />
                                <Input
                                    type="hidden"
                                    name={elementName}
                                    id={elementId}
                                    value={currentValue()}
                                    onChange={handleChange}
                                />
                                {props.fieldStates["error_" + elementId] ===
                                    "has-danger" ? (
                                    <label className="error">
                                        {
                                            props.fieldStates[
                                            "error_message_" + elementId
                                            ]
                                        }
                                    </label>
                                ) : null}
                            </FormGroup>
                        </div>
                    </Col>
                </Row>
            </>
        );

    } else if (elementType == "multi-input") {
        //console.log(elementDesign.type_items);
        let multiInputFields = elementDesign.type_items;
        let defaultElement = {};

        Object.keys(multiInputFields[0]).forEach(function (fieldkey) {
            defaultElement[fieldkey] = multiInputFields[0][fieldkey].default;
        });
        let totalValues = multiInputFields;
        let currValue = [];
        currValue = currentValue();
        if (!currValue || !currValue.length) {
            totalValues = [];
            //addMultiInputValueElement(0,defaultElement);
        } else {
            totalValues = currValue;
        }
        //console.log(totalValues)
        //console.log(totalValues.length);
        let nextIndex = 0;
        let divElements = [];
        if (totalValues.length) {
            for (let key = 0; key < totalValues.length; key++) {
                let multiInputElements = [];
                //Object.keys(totalValues).forEach(function(key) {
                multiInputElements.push(
                    <Row>
                        <Col>
                            <b>{nextIndex + 1}</b>
                            <hr></hr>
                        </Col>
                    </Row>
                );
                Object.keys(multiInputFields[0]).forEach(function (fieldkey) {
                    //console.log(multiInputFields[key][fieldkey]);
                    let listField = multiInputFields[0][fieldkey];
                    let listFieldName =
                        elementName + "[" + key + "][" + fieldkey + "]";
                    let listFieldId = elementId + ":" + key + ":" + fieldkey;
                    let listFieldType = listField.type;
                    if (
                        listField.source &&
                        listField.source == "category_list"
                    ) {
                        listFieldType = "enum";
                        listField.type_items = props.categories;
                    }
                    //defaultElement[fieldkey] = listField.default;
                    if (listFieldType == "string") {
                        multiInputElements.push(
                            <Row>
                                <Col md="6">
                                    <div className="designLabel ">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }>
                                            <Input
                                                type="text"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error" id={props.parent + listFieldId}>
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldType == "boolean") {
                        multiInputElements.push(
                            <Row>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Switch
                                            name={listFieldName}
                                            offColor="success"
                                            offText={
                                                <i className="nc-icon nc-simple-remove" />
                                            }
                                            onColor="success"
                                            onText={
                                                <i className="nc-icon nc-check-2" />
                                            }
                                            value={multiInputValue(
                                                key,
                                                fieldkey
                                            )}
                                            onChange={(value, enabled) =>
                                                handleMultiValueEnumChange(
                                                    listFieldId,
                                                    { value: enabled },
                                                    listField
                                                )
                                            }
                                        />{" "}
                                    </FormGroup>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldType == "integer") {
                        multiInputElements.push(
                            <Row>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }>
                                            <Input
                                                type="number"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error">
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldType == "hidden") {
                        multiInputElements.push(
                            <Row>
                                <Col md="6">
                                    <div className="lblName">
                                        <Label >{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFom">
                                        <FormGroup>
                                            <Input
                                                type="hidden"
                                                name={listFieldName}
                                                id={listFieldName}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldType == "hex_color") {
                        multiInputElements.push(
                            <Row>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFomColr">
                                        <div className="clrChng" style={{ display: "inline-block", border: "none", }}>
                                            <Input
                                                style={{
                                                    background: multiInputValue(
                                                        key,
                                                        fieldkey
                                                    ),
                                                }}
                                                type="color"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className="clrTxt" style={{ display: "inline-block" }}>
                                            <input
                                                //   style={{border:"none" }}
                                                type="text"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                        </div>


                                        {props.fieldStates[
                                            "error_" + listFieldId
                                        ] === "has-danger" ? (
                                            <label className="error" id={props.parent + listFieldId}>
                                                {
                                                    props.fieldStates[
                                                    "error_message_" +
                                                    listFieldId
                                                    ]
                                                }
                                            </label>
                                        ) : null}
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldType == "url") {
                        multiInputElements.push(
                            <Row>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }>
                                            <Input
                                                type="url"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error" id={props.parent + listFieldId}>
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldType == "enum" && listField.type === "array") {
                        multiInputElements.push(
                            <Row>
                                <Col md="6">
                                    <div className="designLabel">
                                        <small className="text-default">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</small>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFom1">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }
                                        >
                                            <SortableSelect
                                                useDragHandle
                                                axis="xy"
                                                onSortEnd={(data) => onSortEndMultiSelect(data, key, fieldkey, listField.type_items, listFieldId, listField)}
                                                // distance={4}
                                                getHelperDimensions={({ node }) => node.getBoundingClientRect()}
                                                className="react-select primary"
                                                classNamePrefix="react-select"
                                                name={listFieldName}
                                                // id={elementId}
                                                isMulti="true"
                                                hideSelectedOptions={false}
                                                value={multiInputMultiEnumValue(
                                                    key,
                                                    fieldkey,
                                                    listField.type_items
                                                )}
                                                options={listField.type_items}
                                                onChange={(value) =>
                                                    handleMultiValueEnumArrayChange(
                                                        listFieldId,
                                                        value,
                                                        listField
                                                    )
                                                }
                                                components={{
                                                    MultiValue: SortableMultiValue,
                                                    MultiValueLabel: SortableMultiValueLabel,
                                                }}
                                                allowSelectAll={true}
                                                closeMenuOnSelect={true}
                                            />

                                            <br></br>
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error">
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                            <div id={listFieldId} tabIndex="0"></div>
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldType == "enum") {
                        //console.log(elementName);

                        multiInputElements.push(
                            <Row>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col sm="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }>
                                            <Select
                                                className="react-select primary"
                                                classNamePrefix="react-select"
                                                name={listFieldName}
                                                // id={listFieldId}
                                                value={multiInputEnumValue(
                                                    key,
                                                    fieldkey,
                                                    listField.type_items
                                                )}
                                                options={listField.type_items}
                                                onChange={(value) =>
                                                    handleMultiValueEnumChange(
                                                        listFieldId,
                                                        value,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error" id={props.parent + listFieldId}>
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                            <div id={listFieldId} tabIndex="0"></div>
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldType == "file_upload") {
                        multiInputElements.push(
                            <Row>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">
                                            {listField.label}
                                            {listField.size ? (
                                                <span>
                                                    ({listField.size})
                                                </span>
                                            ) : (
                                                ""
                                            )}{listField.required ? <span class="text-danger"> * </span> : ''}
                                        </Label>
                                    </div>
                                </Col>
                                <Col sm="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }>
                                            <ImageUpload
                                                imageDetails={listField}
                                                elementValue={
                                                    props.currentTabConfig
                                                        ? multiInputValue(
                                                            key,
                                                            fieldkey
                                                        )
                                                        : ""
                                                }
                                                id={listFieldId}
                                                handleEnumChange={(id, image) => handleMultiImageChange(listFieldId, image, fieldkey)}
                                            // handleEnumChange={handleEnumChange}
                                            />
                                            <Input
                                                type="hidden"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error" id={props.parent + listFieldId}>
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldType == "html") {
                        multiInputElements.push(
                            <Row>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col sm="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }>
                                            <textarea
                                                type="textarea"
                                                className="txtarea"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error" id={props.parent + listFieldId}>
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else {
                        multiInputElements.push(
                            <Row>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col sm="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }>
                                            <Input
                                                type="text"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error" id={props.parent + listFieldId}>
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    }
                });
                // if(nextIndex > 0){
                let removeIndex = nextIndex + 1;
                multiInputElements.push(
                    <Button
                        className="btn-smb btnRd"
                        type="button"
                        onClick={(value) =>
                            removeMultiInputValueElement(removeIndex)
                        }>
                        Remove
                    </Button>
                );
                divElements.push(
                    <SortableChildDiv key={nextIndex} index={nextIndex} >
                        <Accordion preExpanded={[totalValues.length - 1]} allowZeroExpanded >
                            <AccordionItem key={nextIndex} uuid={nextIndex}>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        <div id="reorder-column" style={{ float: "left", marginRight: "15px" }}>
                                            <DragHandle />
                                        </div>
                                        {nextIndex + 1}
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    {multiInputElements}
                                </AccordionItemPanel>
                            </AccordionItem>
                        </Accordion>
                    </SortableChildDiv>
                )
                // }
                nextIndex++;
            }
        }
        //})

        element.push(
            <Row>
                <Col md="12">
                    <Label className="subHeading_h4">
                        <b>{elementDesign.label}</b>
                    </Label>
                </Col>
                <Col md="12">
                    <SortableParentDiv useDragHandle
                        onSortEnd={onSortEndMultiInput}
                        axis='xy'
                    // pressDelay={200} 
                    // shouldCancelStart={shouldCancelStart}
                    >
                        <div id={elementId}>
                            {divElements}

                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label className="error" style={{ color: '#FFC0A4' }}>
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }

                                </label>
                            ) : null
                            }
                        </div>
                    </SortableParentDiv>

                </Col>
                <Col md="12">
                    <div className="dflLft">
                        <Button
                            className="btn-smb"
                            type="button"
                            onClick={(value) =>
                                addMultiInputValueElement(nextIndex, defaultElement)
                            }>
                            Add More
                        </Button>
                    </div>

                    {/* {nextIndex>1?
      <Button
          className="btn-round"
          color="danger"
          type="button"
          onClick={(value)=>removeMultiInputValueElement(nextIndex) }
        >Remove</Button>:''} */}
                </Col>
            </Row>
        );
    } else if (elementType == "json") {
        let showField = true;
        if (elementDesign.parent_field) {
            let parentValue = dropDownCheck(elementDesign.parent_field);
            if (parentValue !== elementDesign.parent_value) {
                showField = false;
            }
        }
        let displayField = "";
        if (!showField) {
            displayField = 'none'
        }
        element.push(
            <>
                <Row style={{ display: displayField }}>
                    <Col sm="6">
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}
                            </small>
                        </div>
                        {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                    </Col>

                    <Col sm="6">
                        <div className="inptFom1">
                            <FormGroup
                                className={props.fieldStates["error_" + elementId]}>
                                <textarea
                                    type="textarea"
                                    className="txtarea"
                                    name={elementName}
                                    id={elementId}
                                    rows={8}
                                    style={{ fontFamily: 'monospace' }}
                                    value={currentValue()}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </FormGroup>
                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label className="error" id={props.parent + elementId}>
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }
                                </label>
                            ) : null}
                        </div>
                    </Col>
                </Row>
            </>
        );
    } else if (elementType == "html") {
        let showField = true;
        if (elementDesign.parent_field) {
            let parentValue = dropDownCheck(elementDesign.parent_field);
            if (parentValue !== elementDesign.parent_value) {
                showField = false;
            }
        }
        let displayField = "";
        if (!showField) {
            displayField = 'none'
        }
        element.push(
            <>
                <Row style={{ display: displayField }}>
                    <Col sm="6">
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}
                            </small>
                        </div>
                        {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                    </Col>

                    <Col sm="6">
                        <div className="inptFom1">
                            <FormGroup
                                className={props.fieldStates["error_" + elementId]}>
                                <textarea
                                    type="textarea"
                                    className="txtarea"
                                    name={elementName}
                                    id={elementId}
                                    value={currentValue()}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </FormGroup>
                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label className="error" id={props.parent + elementId}>
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }
                                </label>
                            ) : null}
                        </div>
                    </Col>
                </Row>
            </>
        );
    } else if (elementType == "tag-input") {

        const tags = currentValue() || [];
        const tagContainerStyle = {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '5px',
            padding: '0.375rem 0.75rem',
            border: '1px solid #cad1d7',
            borderRadius: '.25rem',
            backgroundColor: '#fff',
        };

        const tagItemStyle = {
            backgroundColor: '#007bff',
            color: 'white',
            borderRadius: '4px',
            padding: '0.25em 0.6em',
            display: 'flex',
            alignItems: 'center',
            fontSize: '85%',
            fontWeight: '700',
            lineHeight: '1',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            verticalAlign: 'baseline',
            margin: '2px'
        };

        const tagRemoveStyle = {
            marginLeft: '8px',
            cursor: 'pointer',
            border: 'none',
            background: 'none',
            padding: '0',
            fontWeight: 'bold',
            fontSize: '1.2em',
            lineHeight: '1',
            color: 'white',
            opacity: '0.7',
        };

        element.push(
            <Row>
                <Col sm="6">
                    <div className="designLabel">
                        <small className="text-default">
                            {elementDesign.label}{props.data.required ? <span className="text-danger"> * </span> : ""}
                        </small>
                    </div>
                    {helpText !== "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                </Col>
                <Col sm="6">
                    <div className="inptFom1">
                        <div style={tagContainerStyle}>
                            {tags.map((tag, index) => (
                                <div key={index} style={tagItemStyle}>
                                    {tag}
                                    <button type="button" style={tagRemoveStyle} onClick={() => handleRemoveTag(index)}>&times;</button>
                                </div>
                            ))}
                            <Input
                                type="text"
                                value={tagInput}
                                onChange={(e) => setTagInput(e.target.value)}
                                onKeyDown={handleTagInputKeyDown}
                                placeholder="Add text and press Enter"
                                className="border-0"
                                style={{ boxShadow: 'none', flex: 1, minWidth: '120px' }}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
        );
    } else {
        element.push(
            <>
                <Row>
                    <Col sm="6">
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}
                            </small>
                        </div>
                        {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                    </Col>

                    <Col sm="6">
                        <div className="inptFom1">
                            <FormGroup
                                className={props.fieldStates["error_" + elementId]}>
                                <Input
                                    type="text"
                                    name={elementName}
                                    id={elementId}
                                    value={currentValue()}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </FormGroup>
                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label className="error" id={props.parent + elementId}>
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }
                                </label>
                            ) : null}
                        </div>
                    </Col>
                </Row>
            </>
        );
    }

    return (
        <div className="container pd-l0cont">
            <ReactTooltip
                place="top"
                border="true"
                effect="solid"
                type="light"
                html={true}
            />
            {element}
        </div>
    );
};

export default ConfigFormComponent;
